<template>
  <card class="flat p-2">
    <div class="category">
      <b-form-select v-model="selectCategory">
        <b-form-select-option value="Legal">Legal</b-form-select-option>
        <b-form-select-option value="Patent">Patent</b-form-select-option>
        <b-form-select-option value="Tax Accounting">
          Tax Accounting
        </b-form-select-option>
        <b-form-select-option value="Deposition">
          Deposition
        </b-form-select-option>
        <b-form-select-option value="M&A">
          M&A
        </b-form-select-option>
        <b-form-select-option value="Abitration">
          Abitration
        </b-form-select-option>
        <b-form-select-option value="General">General</b-form-select-option>
        <b-form-select-option value="Etc">Etc</b-form-select-option>
      </b-form-select>
      <b-form-input
        v-show="selectCategory === 'Etc'"
        v-model="category"
        autocomplete="off"
        placeholder="Type your category"
        class="ml-4"
      ></b-form-input>
    </div>
    <div class="upload-area mt-2">
      <div class="upload">
        <h3>Source File</h3>
        <file-draggable
          ref="source"
          v-model="sourceFiles"
          class="file-draggable"
          :placeholder="`Drop Source Language Files Here\nor Click to Select`"
        ></file-draggable>
      </div>
      <div class="upload ml-4">
        <h3>Target File</h3>
        <file-draggable
          ref="target"
          v-model="targetFiles"
          class="file-draggable"
          :placeholder="`Drop Translated Files Here\nor Click to Select`"
        ></file-draggable>
      </div>
    </div>
    <div slot="footer" class="training-footer">
      <b-button
        class="mr-4"
        variant="success"
        @click="uploadSourceTargetFiles"
        :disabled="(sourceFiles.length <= 0 && targetFiles.length <= 0) || $sync.sync"
      >
        Upload Source & Target
      </b-button>
      <b-button class="mr-4" variant="info" @click="reset">
        Reset
      </b-button>
      <b-button class="mr-4" variant="dark" @click="goToList">
        List
      </b-button>
    </div>
  </card>
</template>

<script>
import FileDraggable from './FileDraggable'
export default {
  props: {
    files: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    FileDraggable,
  },
  data: () => ({
    selectCategory: 'Legal',
    category: 'Legal',
    sourceFiles: [],
    targetFiles: [],
  }),
  mounted() {
    this.$refs.source.stageFiles(this.files)
  },
  methods: {
    reset() {
      this.$refs.source.clear()
      this.$refs.target.clear()
    },
    async uploadSourceTargetFiles() {
      await this.$sync.uploadFiles(this.sourceFiles, this.upload)
      this.$refs.source.clear()
      await this.$sync.uploadFiles(this.targetFiles, this.upload)
      this.$refs.target.clear()
      this.goToList()
    },
    goToList() {
      this.$router.replace('/training/list')
    },
    async upload(file) {
      const formData = new FormData()
      formData.append('doc', file)
      if (this.category) {
        formData.append('category', this.category)
      }
      await this.$slowbro.post('/me/company/files', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    },
  },
  filters: {
    toDateText(value) {
      const date = new Date(value)
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
  },
  watch: {
    selectCategory(val, oldva) {
      if (val === 'Etc') {
        this.category = ''
      } else {
        this.category = val
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.category {
  display: flex;
  height: 50px;
  select {
    width: 300px;
  }
  input[type='text'] {
    width: 300px;
  }
}
.upload-area {
  display: flex;
  justify-content: space-between;
  .upload {
    flex: 1;
  }
  .file-draggable {
    box-sizing: border-box;
    height: 200px;
  }
}
.training-footer {
  display: flex;
  justify-content: center;
}
.toast-message {
  position: fixed;
  bottom: 20px;
  right: 10px;
  z-index: 10000001 !important;
}
</style>
